import { useField } from "formik";
import React from "react";
import { FieldFeedbackLabel } from "./FieldFeedbackLabel";

const getFieldCSSClasses = (touched, errors) => {
  const classes = [
    "w-full h-11 pl-3 pr-8 mt-1.5 text-sm font-medium text-gray-600 rounded-lg border-none hover:bg-gray-50 focus:outline-none focus:border-primary placeholder:text-gray-400 disabled:bg-gray-100 disabled:text-gray-600 drop-shadow"
  ];
  if (touched && errors) {
    classes.push("is-invalid");
  }

  return classes.join(" ");
};

export function Select({
  label,
  withFeedbackLabel = true,
  type = "text",
  customFeedbackLabel,
  children,
  ...props
}) {
  const [field, meta] = useField(props);
  const { touched, error } = meta;
  return (
    <>
      {label && (
        <label className="text-sm text-gray-500 font-medium">{label}</label>
      )}
      <select
        className={getFieldCSSClasses(touched, error)}
        {...field}
        {...props}
      >
        {children}
      </select>
      {withFeedbackLabel && error && (
        <>
          <FieldFeedbackLabel
            error={error}
            touched={touched}
            label={label}
            type={type}
            customFeedbackLabel={customFeedbackLabel}
          />
        </>
      )}
    </>
  );
}
